import React from "react";
import "./CertificateGroupingRequest.scss";
import CertificateGroupingRequestList from "../../features/CertificateGroupingRequestList/CertificateGroupingRequestList";

const CertificateGroupingRequest = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingRequestList />
    </div>
  );
};

export default CertificateGroupingRequest;
